import React from 'react';
import { TooltipHost, DirectionalHint, TooltipDelay, Icon, Toggle } from 'office-ui-fabric-react';
import { Description } from '../../common/InfoableComponent';

export const SectionToggle = (props: {
    key: string;
    checked: boolean;
    disabled?: boolean;
    description?: string | JSX.Element;
    label: string;
    onChange: (value: boolean) => void;
}) => <li key={props.key}>
        <div className="cb-wrap">
            <div className="title" title={props.label}>
                {props.label}
                {!!props.description && <TooltipHost
                    calloutProps={{ directionalHint: DirectionalHint.topLeftEdge }}
                    tooltipProps={{ onRenderContent: () => <Description value={props.description} /> }}
                    hostClassName="align-center"
                    className='field-hint'
                    delay={TooltipDelay.zero}
                    id='customID'
                >
                    <Icon
                        onClick={(e) => e.stopPropagation()}
                        iconName="Info"
                        className='callout-icon' />
                </TooltipHost>}
            </div>
            <Toggle
                checked={props.checked}
                disabled={props.disabled}
                onChange={(e: any, c?: boolean) => props.onChange(!!c)} />
        </div>
    </li>;
